import { render, staticRenderFns } from "./areamanage.vue?vue&type=template&id=ed500e1c&scoped=true&"
import script from "./areamanage.vue?vue&type=script&lang=js&"
export * from "./areamanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed500e1c",
  null
  
)

export default component.exports